import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'faire_direct-credit_faq_modal-view';

/**
 * User opens the FD Credit FAQ Modal.
 */
export function trackFaireDirectCreditFaqModalView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
